import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Firebase configuration fetched from environment variables

const firebaseConfig = {

    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
        
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Auth
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1');
const storage = getStorage(app);

if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true') {
    connectFunctionsEmulator(
        functions,
        process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || '127.0.0.1',
        Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001)
    );
}

// Export Firebase functionalities
export { auth, app, provider, createUserWithEmailAndPassword, signInWithEmailAndPassword, db, functions, httpsCallable, storage   };
